import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import InputFormBorder from '../../components/Common/InputFormBorder/InputFormBorder';
import Button from '../../components/Common/Button/Button';
import useForm from '../../helpers/useForm';
import ContentApp from '../../components/ContentApp';
import FixedButton from '../../components/Common/FixedButton/FixedButton';
import { logout } from '../../actions/associatesActions';
import { useDispatch } from 'react-redux';
import { WelletContext } from '../../context/WelletContext';
import { Spinner } from '../../components/Common/Spinner/Spinner';
import ErrorBox from '../../components/Common/ErrorBox/ErrorBox';
import Header from '../../components/Common/Header/Header';

const NameFormValidation = ({ history }) => {
  const { t } = useTranslation();
  const [submitting, setSubmitting] = useState(false);
  const [errorUser, setErrorUser] = useState('');
  const dispatch = useDispatch();
  const welletContext = useContext(WelletContext);

  const handleSignOut = () => {
    dispatch(logout());
    history.push('/login');
  };

  function validate(values) {
    const errors = {};
    if (!values.firstName) errors.firstName = t('nameError.EMPTY_NAME');
    if (!values.lastName) errors.lastName = t('nameError.EMPTY_LASTNAME');
    return errors;
  }

  const submitForm = async () => {
    setSubmitting(true);
    setErrorUser('');
    try {
      const result = await welletContext.apis.tickets.put(`users/simple/data`, {
        firstName: values.firstName,
        lastName: values.lastName,
      });

      if (result?.data === true) {
        window.location.href = '/';
      } else {
        setErrorUser(result?.data?.message);
      }
    } catch (error) {
      console.error(error);
      setErrorUser(t('networkError'));
    } finally {
      setSubmitting(false);
    }
  };

  const { values, errors, handleChange, handleSubmit } = useForm(submitForm, validate);

  return (
    <>
      <Header showBack={false} />
      <ContentApp background={true}>
        <div className='font-medium bold text-white' style={{ lineHeight: '1.6rem' }}>
          {t('enterYourDetails')}
        </div>
        <div className='mt-2 text-secondary subtitle' style={{ lineHeight: '1.3rem' }}>
          {t('ensureCorrectlyWritten')}
        </div>

        <form onSubmit={handleSubmit}>
          <div className='mt-4'>
            <InputFormBorder
              name='firstName'
              type='text'
              value={values.firstName || ''}
              error={errors.firstName}
              label={t('profile.firstName')}
              placeholder={t('profile.firstName')}
              onChange={handleChange}
            />
          </div>

          <div className='mt-4'>
            <InputFormBorder
              name='lastName'
              type='text'
              value={values.lastName || ''}
              error={errors.lastName}
              label={t('profile.lastName')}
              placeholder={t('profile.lastName')}
              onChange={handleChange}
            />
          </div>

          {errorUser && (
            <div className='mt-4'>
              <ErrorBox title={errorUser} />
            </div>
          )}

          <div className='mt-4'>
            <div
              className='text-center mt-3 text-secondary'
              style={{
                position: 'fixed',
                bottom: 40,
                width: '100%',
                left: 0,
                marginBottom: '25%',
              }}
              onClick={handleSignOut}
            >
              {t('menu.logout')}
            </div>

            <FixedButton>
              <Button
                size='large'
                fontSize='18px'
                text={
                  submitting ? (
                    <div className='d-flex justify-content-center'>
                      <Spinner size={25} color='#000' />
                    </div>
                  ) : (
                    t('continue')
                  )
                }
                typeIcon='arrow'
                iconColor='#000'
              />
            </FixedButton>
          </div>
        </form>
      </ContentApp>
    </>
  );
};

export default NameFormValidation;
